<template>
    <div class="ldc-time">
        <div v-if="$detect == 'web'">
            <ldc-dropdown
                trigger="click"
                :action-close="true"
                @dataActive="activeShowDrop = $event">
                <input type="text" v-model="model" class="fs-14px px-2"
                    :readonly="true"
                    :placeholder="placeholder">
                <ldc-dropdown-menu>
                    <div class="d-flex justify-content-center ldc-time-content position-relative">
                        <div class="w-time" hours>
                            <p class="mb-0 null" role="button" v-for="item in [-1,-2]" :key="item"></p>
                            <p :class="{
                                'mb-0': true,
                                'active': hour === item
                            }" role="button" v-for="(item, index) in hours" :key="item"
                                @click="selectHour(index)">
                                {{ item.toString().length == 2 ? item : '0' + item}}
                            </p>
                            <p class="mb-0 null" role="button" v-for="item in [-3,-4]" :key="item"></p>
                        </div>
                        <div class="w-time" minutes>
                            <p class="mb-0 null" role="button" v-for="item in [-1,-2]" :key="item"></p>
                            <p :class="{
                                'mb-0': true,
                                'active': minute === item
                            }" role="button" v-for="(item, index) in minutes" :key="item"
                                @click="selectMinute(index)">
                                {{ item.toString().length == 2 ? item : '0' + item}}
                            </p>
                            <p class="mb-0 null" role="button" v-for="item in [-3,-4]" :key="item"></p>
                        </div>
                        <div class="w-time" seconds v-if="showSeconds">
                            <p class="mb-0 null" role="button" v-for="item in [-1,-2]" :key="item"></p>
                            <p :class="{
                                'mb-0': true,
                                'active': second === item
                            }" role="button" v-for="(item, index) in seconds" :key="item"
                                @click="selectSecond(index)">
                                {{ item.toString().length == 2 ? item : '0' + item}}
                            </p>
                            <p class="mb-0 null" role="button" v-for="item in [-3,-4]" :key="item"></p>
                        </div>
                        <div class="border-time position-absolute">
                            <div></div>
                        </div>
                    </div>
                    <div class="text-right btn-action-time">
                        <button class="fs-14px btn" close-dropdown>cancel</button>
                        <button class="fs-14px btn text-primary fw-600 ml-2" close-dropdown>OK</button>
                    </div>
                </ldc-dropdown-menu>
            </ldc-dropdown>
        </div>
        <div v-else>
            <div @click="active = true" class="input-time-mobile">{{model === '' ? placeholder : model}}</div>
            <div :class="{
                'ldc-select-time-mobile position-fixed': true,
            }" v-show="active">
            <div :class="{
                    'ldc-content-time-mobile bg-white pt-2': true,
                    'radius-ios': !$isAndroid,
                    'rounded': $isAndroid,
                    'ldc-time-mobile-hm': !showSeconds,
                    'ldc-time-mobile-hms': showSeconds,
                }" v-click-outside="outside">
                <div class="title-select-mobile text-center border-bottom fw-600" v-if="showTitleMobile">{{titleMobile}}</div>
                <div class="select-mobile-main">
                    <div class="d-flex justify-content-center ldc-time-content position-relative">
                        <div class="w-time" hours>
                            <p class="mb-0 null" role="button" v-for="item in [-1,-2]" :key="item"></p>
                            <p :class="{
                                'mb-0': true,
                                'active': hour === item
                            }" role="button" v-for="(item, index) in hours" :key="item"
                                @click="selectHour(index)">
                                {{ item.toString().length == 2 ? item : '0' + item}}
                            </p>
                            <p class="mb-0 null" role="button" v-for="item in [-3,-4]" :key="item"></p>
                        </div>
                        <div class="w-time" minutes>
                            <p class="mb-0 null" role="button" v-for="item in [-1,-2]" :key="item"></p>
                            <p :class="{
                                'mb-0': true,
                                'active': minute === item
                            }" role="button" v-for="(item, index) in minutes" :key="item"
                                @click="selectMinute(index)">
                                {{ item.toString().length == 2 ? item : '0' + item}}
                            </p>
                            <p class="mb-0 null" role="button" v-for="item in [-3,-4]" :key="item"></p>
                        </div>
                        <div class="w-time" seconds v-if="showSeconds">
                            <p class="mb-0 null" role="button" v-for="item in [-1,-2]" :key="item"></p>
                            <p :class="{
                                'mb-0': true,
                                'active': second === item
                            }" role="button" v-for="(item, index) in seconds" :key="item"
                                @click="selectSecond(index)">
                                {{ item.toString().length == 2 ? item : '0' + item}}
                            </p>
                            <p class="mb-0 null" role="button" v-for="item in [-3,-4]" :key="item"></p>
                        </div>
                        <div class="border-time position-absolute">
                            <div></div>
                        </div>
                    </div>
                </div>
                <div class="button-select border-top">
                    <div v-if="!$isAndroid" class="d-flex">
                        <div class="w-50 text-center" @click="active = false">cancel</div>
                        <div class="w-50 text-center border-left fw-600" @click="active = false">OK</div>
                    </div>
                    <div v-else class="d-flex justify-content-end text-uppercase">
                        <div class="px-3" @click="active = false">cancel</div>
                        <div class="px-3 fw-600" @click="active = false">OK</div>
                    </div>
                </div>
            </div>
        </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        placeholder: {
            type: String,
            default: '',
        },
        value: {
            type: String,
            default: '',
        },
        showSeconds: {
            type: Boolean,
            default: true,
        },
        minHours: {
            type: Number,
            default : 0
        },
        maxHours: {
            type: Number,
            default: 23,
        },
        valueHours: {
            type: Array,
        },
        minMinutes: {
            type: Number,
            default: 0,
        },
        maxMinutes: {
            type: Number,
            default: 59,
        },
        jumpMinutes: {
            type: Number,
            default: 1,
        },
        titleMobile: {
            type: String,
            default: '',
        },
        showTitleMobile: {
            type: Boolean,
            default: true,
        },
        clickoutside: {
            type: Boolean,
            default: true,
        }
    },
    data() {
        return {
            model: '',
            hours: [],
            minutes: [],
            seconds: [],
            activeShowDrop: false,
            hour: '',
            minute: '',
            second: '',
            scrollHours: null,
            scrollMinutes: null,
            scrollSeconds: null,
            change: null,
            active: false,
            maxH: 23,
            minH: 0,
            maxM: 59,
            minM: 0,
        }
    },
    watch: {
        value(val){
            this.model = val;
        },
        model(val){
            this.$emit('input', val);
            if(this.change) this.change();
        },
        activeShowDrop(val){
            if(val){
                this.getTimeNow();
            }
        },
        active(val){
            if(val){
                setTimeout(() => {
                    this.getTimeNow();
                }, 0)
            }
        }
    },
    mounted(){
        if(this.value !== ''){
            this.checkValue()
        }
        let p = this.$el.querySelector('.ldc-time-content p');
        let height = 30;
        
        let hours = this.$el.querySelector('[hours]');
        let hoursActive;
        if(hours){
            let scrollHour = () => {
                if(p){
                    height = p.offsetHeight;
                }
                if(this.scrollHours) clearTimeout(this.scrollHours);
                hoursActive = hours.scrollTop / height;
                let index;
                if(hoursActive % 1 < 0.5){
                    index = Math.floor(hoursActive);
                }else{
                    index = Math.ceil(hoursActive);
                }
                this.hour = this.hours[index];
                let hour = this.hour.toString().length == 2 ? this.hour : '0'+this.hour;
                this.model =  hour + ':' + (this.minute.toString().length == 2 ? this.minute : '0'+this.minute) + (this.showSeconds ? ':' + this.second : '');
                this.scrollHours = setTimeout(() => {
                    hours.scrollTo({
                        top: index*height,
                        left: 0,
                        behavior: 'smooth'
                    })
                }, 100)
            }
            hours.addEventListener('scroll', scrollHour, false);
        }

        let minutes = this.$el.querySelector('[minutes]');
        let minutesActive;
        if(minutes){
            let scrollMinute = () => {
                if(p){
                    height = p.offsetHeight;
                }
                if(this.scrollMinutes) clearTimeout(this.scrollMinutes);
                hoursActive = minutes.scrollTop / height;
                let index;
                if(hoursActive % 1 < 0.5){
                    index = Math.floor(hoursActive);
                }else{
                    index = Math.ceil(hoursActive);
                }
                this.minute = this.minutes[index];
                let minute = this.minute.toString().length == 2 ? this.minute : '0'+this.minute;
                this.model = (this.hour.toString().length == 2 ? this.hour : '0'+this.hour) + ':' + minute + (this.showSeconds ? ':' + this.second : '');
                this.scrollMinutes = setTimeout(() => {
                    minutes.scrollTo({
                        top: index*height,
                        left: 0,
                        behavior: 'smooth'
                    })
                }, 100)
            }
            minutes.addEventListener('scroll', scrollMinute, false);
        }
        if(this.showSeconds){
            let seconds = this.$el.querySelector('[seconds]');
            let secondsActive;
            if(seconds){
                let scrollSeconds = () => {
                    if(p){
                        height = p.offsetHeight;
                    }
                    if(this.scrollSeconds) clearTimeout(this.scrollSeconds);
                    secondsActive = seconds.scrollTop / height;
                    let index;
                    if(hoursActive % 1 < 0.5){
                        index = Math.floor(secondsActive);
                    }else{
                        index = Math.ceil(secondsActive);
                    }
                    this.second = this.seconds[index];
                    let second = this.second.toString().length == 2 ? this.second : '0'+this.second;
                    this.model = (this.hour.toString().length == 2 ? this.hour : '0'+this.hour) + ':' + (this.minute.toString().length == 2 ? this.minute : '0'+this.minute) + (this.showSeconds ? ':' + second : '');
                    this.scrollSeconds = setTimeout(() => {
                        seconds.scrollTo({
                            top: index*height,
                            left: 0,
                            behavior: 'smooth'
                        })
                    }, 100)
                }
                seconds.addEventListener('scroll', scrollSeconds, false);
            }
        }
    },
    created() {
        this.model = this.value;
        let listeners = this.$listeners
        if(typeof(listeners.change) == 'function'){
            this.change = listeners.change;
            if(process.env.NODE_ENV == 'development'){
                console.warn('Không lên sử dụng hàm @change cho mục đích call api hay thực hiện thao tác nặng vì nó sẽ chạy vòng lặp thự thi lại rất nhiều lần');
            }
        }


        if(typeof(this.valueHours) == 'undefined'){
            this.hours = [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23];
        }else{
            let maxHours = 23;
            if(this.maxHours < 0 || this.maxHours >= 24){
                console.error('Prop maxHours năm trong khoảng giá trị từ 0 đến 23 nên giá trị maxHours về giá trị mặc định là 23h');
            }else{
                maxHours = this.maxHours;
            }
            let minHours = 0;
            if(this.minHours < 0 || this.minHours >= 24){
                console.error('Prop minHours năm trong khoảng giá trị từ 0 đến 23 nên giá trị minHours về giá trị mặc định là 0h');
            }else{
                minHours = this.minHours;
            }
            this.maxH = maxHours;
            this.minH = minHours;
            this.valueHours.map(item => {
                if(typeof(item) == 'number'){
                    if(item >= 0 && item < 24){
                        if(item >= minHours && item < maxHours){
                            this.hours.push(item);
                        }else{
                            console.error(`Giá trị của giờ phải nằm trong khoảng từ ${this.minHours} đến ${maxHours}, ${item} không thuộc khoảng thời gian cho phép sẽ không được hiển thị`)
                        }
                    }else{
                        console.error(`Giá trị của giờ phải nằm trong khoảng từ 0 đến 23, ${item} không thuộc khoảng thời gian cho phép sẽ không được hiển thị`);
                    }
                }else{
                    console.error(`${item} phải là 1 số`);
                }
            })
        }

        let minMinutes, maxMinutes, jumpMinutes;
        if(this.minMinutes < 0 || this.minMinutes >= 60){
            console.error('Prop minMinutes nằm trong khoảng giá trị từ 0 đến 59 nên giá trị minMinutes về giá trị mặc định là 0');
        }else{
            minMinutes = this.minMinutes;
        }
        if(this.maxMinutes < 0 || this.maxMinutes >= 60){
            console.error('Prop maxMinutes nằm trong khoảng giá trị từ 0 đến 59 nên giá trị maxMinutes về giá trị mặc định là 59');
        }else{
            maxMinutes = this.maxMinutes;
        }
        this.maxM = maxMinutes;
        this.minM = minMinutes;
        if(this.jumpMinutes < 0 || this.jumpMinutes >= 60){
            console.error('Prop jumpMinutes nằm trong khoảng giá trị từ 0 đến 59 nên giá trị minMinutes về giá trị mặc định là 1');
        }else{
            jumpMinutes = this.jumpMinutes;
        }

        let startMinutes = minMinutes;
        for(;;){
            if(startMinutes > maxMinutes){
                break;
            }
            this.minutes.push(startMinutes);
            startMinutes += jumpMinutes;
        }

        if(this.showSeconds){
            for(let i = 0; i < 60; i++){
                this.seconds.push(i);
            }
        }
    },
    methods: {
        checkValue(){
            let check = this.value.split(':');
            if((check.length == 2 && !this.showSeconds) || (check.length == 3 && this.showSeconds)){
                if(check[0]*1 <= this.maxH && this.minH <= check[0]*1 && check[0].length == 2){
                    if(check[1]*1 <= this.maxM && this.minM <= check[1]*1 && check[1].length == 2){
                        if(this.showSeconds){
                            if(check[2]*1 <= 59 && check[2]*1 >= 0 && check[2].length == 2){
                                let hours = this.getHourModel(check[0]*1);
                                let minutes = this.getMinutesModel(check[1]*1);
                                this.model = (hours.toString().length == 2 ? hours : '0'+hours) +  ':' + (minutes.toString().length == 2 ? minutes : '0'+minutes) + (this.showSeconds ? ':'+check[2] : '');
                                return true;
                            }
                            this.notification(1);
                            return false;
                        }
                        let hours = this.getHourModel(check[0]*1);
                        let minutes = this.getMinutesModel(check[1]*1);
                        this.model = (hours.toString().length == 2 ? hours : '0'+hours) +  ':' + (minutes.toString().length == 2 ? minutes : '0'+minutes) + (this.showSeconds ? ':'+check[2] : '');
                        return true;
                    }
                    this.notification(2);
                    return false;
                }
                this.notification(3);
                return false;
            }
            this.notification(4);
            return false;
        },
        getHourModel(hours){
            let key, range;
            this.hours.map((item, index) => {
                if(index == 0){
                    key = 0;
                    range =  Math.abs(hours - item);
                }else{
                    if(Math.abs(hours - item) < range){
                        key = index;
                        range = Math.abs(hours - item);
                    }
                }
            });
            return this.hours[key];
        },
        getMinutesModel(minutes){
            let key, range;
            this.minutes.map((item, index) => {
                if(index == 0){
                    key = 0;
                    range =  Math.abs(minutes - item);
                }else{
                    if(Math.abs(minutes - item) < range){
                        key = index;
                        range = Math.abs(minutes - item);
                    }
                }
            });
            return this.minutes[key];
        },
        notification(){
            console.warn(`Sai định dạng thời gian: ${this.value}, giá trị sẽ gán về trị hiện tại`);
        },
        selectHour(index){
            let p = this.$el.querySelector('.ldc-time-content p');
            let height = 30;
            if(p){
                height = p.offsetHeight;
            }
            let hours = this.$el.querySelector('[hours]');
            this.hour = this.hours[index];
            hours.scrollTo({
                top: index*height,
                left: 0,
                behavior: 'smooth'
            })
        },
        selectMinute(index){
            let p = this.$el.querySelector('.ldc-time-content p');
            let height = 30;
            if(p){
                height = p.offsetHeight;
            }
            let minutes = this.$el.querySelector('[minutes]');
            this.minute = this.minutes[index];
            minutes.scrollTo({
                top: index*height,
                left: 0,
                behavior: 'smooth'
            })
        },
        selectSecond(index){
            let p = this.$el.querySelector('.ldc-time-content p');
            let height = 30;
            if(p){
                height = p.offsetHeight;
            }
            let seconds = this.$el.querySelector('[seconds]');
            this.second = this.seconds[index];
            seconds.scrollTo({
                top: index*height,
                left: 0,
                behavior: 'smooth'
            })
        },
        getTimeNow(){
            let time = new Date();
            if(this.model !== ''){
                time = this.model.split(':');
            }
            let hour = this.getHours(this.model !== '' ? time[0] : time.getHours());
            let minute = this.getMinutes(this.model !== '' ? time[1] : time.getMinutes());
            let second = this.getSeconds(this.model !== '' ? time[2] : time.getSeconds());
            let hours = hour.toString().length == 2 ? hour : '0' + hour;
            let minutes = minute.toString().length == 2 ? minute : '0' + minute;
            let seconds = second != undefined ? (second.toString().length == 2 ? second : '0' + second) : '';
            this.hour = hours;
            this.minute = minutes;
            this.second = seconds;
            this.model = hours + ':' + minutes + (this.showSeconds ? ':' + seconds : '');
        },
        getHours(hours){
            let key, range;
            this.hours.map((item, index) => {
                if(index == 0){
                    key = 0;
                    range =  Math.abs(hours - item);
                }else{
                    if(Math.abs(hours - item) < range){
                        key = index;
                        range = Math.abs(hours - item);
                    }
                }
            });
            let p = this.$el.querySelector('.ldc-time-content p');
            let height = 30;
            if(p){
                height = p.offsetHeight;
            }
            let hoursDom = this.$el.querySelector('[hours]');
            if(hoursDom){
                hoursDom.scrollTo({
                    top: key*height,
                    left: 0,
                    behavior: 'smooth'
                });
            }
            return this.hours[key];
        },
        getMinutes(minutes){
            let key, range;
            this.minutes.map((item, index) => {
                if(index == 0){
                    key = 0;
                    range =  Math.abs(minutes - item);
                }else{
                    if(Math.abs(minutes - item) < range){
                        key = index;
                        range = Math.abs(minutes - item);
                    }
                }
            });
            let p = this.$el.querySelector('.ldc-time-content p');
            let height = 30;
            if(p){
                height = p.offsetHeight;
            }
            let minutesDom = this.$el.querySelector('[minutes]');
            if(minutesDom){
                minutesDom.scrollTo({
                    top: key*height,
                    left: 0,
                    behavior: 'smooth'
                });
            }
            return this.minutes[key];
        },
        getSeconds(seconds){
            let key, range;
            this.seconds.map((item, index) => {
                if(index == 0){
                    key = 0;
                    range =  Math.abs(seconds - item);
                }else{
                    if(Math.abs(seconds - item) < range){
                        key = index;
                        range = Math.abs(seconds - item);
                    }
                }
            });
            let p = this.$el.querySelector('.ldc-time-content p');
            let height = 30;
            if(p){
                height = p.offsetHeight;
            }
            let secondsDom = this.$el.querySelector('[seconds]');
            if(secondsDom){
                secondsDom.scrollTo({
                    top: key*height,
                    left: 0,
                    behavior: 'smooth'
                });
            }
            return this.seconds[key];
        },
        outside(e){
            if(this.clickoutside && this.$el.querySelector('.ldc-select-time-mobile') === e.target){
                this.active = false;
            }
        }
    }
}
</script>
